import script from "./CloudDiskIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./CloudDiskIndex.vue?vue&type=script&setup=true&lang=js"

import "./CloudDiskIndex.vue?vue&type=style&index=0&id=2a24e945&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a24e945"]])

export default __exports__